<template>
  <div
    v-if="items"
    class="flex items-center ph3 pb5 "
    style="max-width: fit-content; margin: 0 auto;"
  >
    <div
      v-if="title"
      class="b pr3"
      :class="{
        'purple': brand === 'lh',
        'dark-gray': brand === 'lq'
      }"
      v-html="title"
      ref="title"
    />
    <div
      v-if="icon"
      class="ba bw2 br-100 flex items-center justify-center"
      :class="{
        'b--purple bg-white purple': brand === 'lh',
        'b--dark-gray bg-white dark-gray': brand === 'lq'
      }"
      style="width: 4.7rem; height: 4.7rem;"
      ref="iconCircle"
    >
      <simple-svg
        :filepath="icon"
        style="width: 2.5rem; height: 2.5rem;"
      />
    </div>
    <div class="relative flex">
      <div
        ref="bar"
        class="absolute"
        :class="{
          'b--purple bg-purple': brand === 'lh',
          'b--dark-gray bg-dark-gray': brand === 'lq'
        }"
        style="
          height: 0.25rem;
          left: 0;
          top: 50%;
          transform: translate(0, -50%)
        "
      />
      <div
        ref="section"
        v-for="(item, index) in items"
        :key="index"
        class="flex items-center"
        v-show="items"
      >
        <div
          class="w2"
          style="height: 0.25rem"
        />
        <div
          class="ba bw2 br-100 pointer relative"
          style="
            width: 1.5rem;
            height: 1.5rem
          "
          ref="dots"
          :class="{
            'bg-white': active !== index,
            'bg-purple': active === index && brand === 'lh',
            'bg-dark-gray': active === index && brand === 'lq',
            'b--purple': brand === 'lh',
            'b--dark-gray': brand === 'lq'
          }"
          @click="$store.commit('setActiveTab', index); activeDot($event);"
        >
          <div
            class="absolute tc br2 ph2 pv2 white"
            :class="{
              'bg-purple': brand === 'lh',
              'bg-dark-gray': brand === 'lq'
            }"
            style="
              top: -3rem;
              left: -0.25rem;
              filter:drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))
            "
            v-show="active === index"
          >
            <div
              class="nowrap lh-copy fw6 f7"
              v-html="item"
            />
            <div
              class="triangle-down-small absolute"
              :class="{
                'b--purple': brand === 'lh',
                'b--dark-gray': brand === 'lq'
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  name: 'NavSecondary',
  props: {
    brand: {
      type: String,
      default: 'lh'
    },
    icon: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    active () {
      return this.$store.state.activeTab
    },
    dotCount () {
      return this.$refs.dots.length
    }
  },
  mounted  () {
    this.animEnter()
  },
  methods: {
    animEnter () {
      const title = this.$refs.title
      const bar = this.$refs.bar
      const iconCircle = this.$refs.iconCircle
      const dots = this.$refs.dots
      const tl = gsap.timeline()
      if (title) {
        tl.from(title, {
          x: -200,
          delay: 0.5,
          opacity: 0,
          duration: 0.2
        })
      }
      if (iconCircle) {
        tl.from(iconCircle, {
          rotation: 180,
          x: 40,
          opacity: 0,
          duration: 0.2,
          stagger: 0.1
        })
      }
      if (bar) {
        tl.fromTo(bar,
          {
            width: 0
          },
          {
            width: 100 + '%',
            delay: 0.3,
            duration: this.dotCount * 0.2,
            ease: 'none'
          }
        )
      }
      if (dots) {
        tl.fromTo(dots,
          {
            scale: 0
          },
          {
            scale: 1,
            duration: 0.2,
            stagger: 0.2,
            delay: -(this.dotCount * 0.2) + 0.2,
            ease: 'back.out(1.7)'
          }
        )
      }
    },
    activeDot (event) {
      gsap.fromTo(event.target,
        {
          scale: 1
        },
        {
          scale: 1.25,
          duration: 0.2
        }
      )
      gsap.fromTo(event.target,
        {
          scale: 1.25
        },
        {
          scale: 1.1,
          duration: 0.2,
          delay: 0.2
        }
      )
    }
  }
}
</script>
